// extracted by mini-css-extract-plugin
export default {"success":"CurrentSpendTile_success__yO6Oz","warning":"CurrentSpendTile_warning__Tw-KU"};